var React = require('react');

function FacebookIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.0703 0H2.92969C1.31439 0 0 1.31439 0 2.92969V17.0703C0 18.6856 1.31439 20 2.92969 20h5.89843v-7.0703H6.48438V9.41406h2.34374V7.03125c0-1.93863 1.57698-3.51563 3.51568-3.51563h3.5546v3.51563h-3.5546v2.38281h3.5546l-.5859 3.51564h-2.9687V20h4.7265C18.6856 20 20 18.6856 20 17.0703V2.92969C20 1.31439 18.6856 0 17.0703 0z","fill":"currentColor"}));
}

FacebookIcon.defaultProps = {"fill":"none","viewBox":"0 0 20 20"};

module.exports = FacebookIcon;

FacebookIcon.default = FacebookIcon;
